import Profile from "../views/profile";
import Order from "./../views/Orders/Order";
import OrderDetail from "./../views/Orders/OrderDetail";
import PharmacyOrderList from "../views/Pharmacy/listing";
import PharmacyOrderCreate from "../views/Pharmacy/createOrder";
import PharmacyOrderDetail from "../views/Pharmacy/detail";


const AdminRoutes = [
  {
    path: "/",
    component: <Order />,
  },
  {
    path: "/order-detail/:id",
    component: <OrderDetail />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/pharmacy-orders-list",
    component: <PharmacyOrderList />,
  },
  {
    path: "/create-order",
    component: <PharmacyOrderCreate />,
  },
  {
    path: "/pharmacy-orders-detail",
    component: <PharmacyOrderDetail/>,
  },
];

export default AdminRoutes;
